module.exports = __webpack_public_path__ + "media/entities/2207-28ea6719.png";